if (__COM__) {
	module.exports = require('./employee/LogInAsRoute');
} else {
	module.exports = require('./client/LoginRoute');
}



// WEBPACK FOOTER //
// ./src/js/Login/index.js